/* grecaptcha keeps internal timers alive after React unmounts its widget; they
   eventually fire against torn-down state and throw benign errors from inside
   Google's own script (e.g. "Cannot read properties of undefined (reading
   'M_ID')"). Nothing app-side can patch that code, so silence exactly those —
   everything else still surfaces normally. */
const RECAPTCHA_SOURCE = /recaptcha|gstatic\.com/i;
const RECAPTCHA_MESSAGE = /reading 'M_ID'/;

window.addEventListener('error', (e) => {
  if (RECAPTCHA_SOURCE.test(e.filename || '') || RECAPTCHA_MESSAGE.test(e.message || '')) {
    e.preventDefault();
  }
});

window.addEventListener('unhandledrejection', (e) => {
  const message = e.reason?.message || '';
  const stack = e.reason?.stack || '';
  if (RECAPTCHA_MESSAGE.test(message) || RECAPTCHA_SOURCE.test(stack)) {
    e.preventDefault();
  }
});
